import convert from "convert-units";
import { convertEnergy } from "./convertsUnits";
import { coins_units } from "../constants";

//convierte en unidades equivalentes
  export const convertUnits = (value, unita, unitb) => {

    try {
      if(!value){
        return 0
      }else{

      if (unita === unitb) {
        return value;
      }

      // ✅ Verificar si son monedas
      const esMoneda = (unidad) =>
        coins_units.some((moneda) => moneda.value === unidad);

      // Si ambas son monedas, por ahora retornar el mismo valor
      if (esMoneda(unita) && esMoneda(unitb)) {
        // TODO: Implementar conversión de divisas con tasas de cambio
        return value;
      }

      const result = convert(value).from(unita).to(unitb);

      // Si la conversión falla y devuelve NaN, vamos a intentar con la función personalizada
      if (isNaN(result)) {
        //console.log('La librería convert-units no pudo realizar la conversión. Intentando con la función personalizada...');
        return value;
      }
      return result;
    }
    } catch (error) {
      try {
        const result2 = convertEnergy(value, unita, unitb);
        return result2;
      } catch {
        // Si ocurre un error en la librería o en la función personalizada, lo capturamos
        console.error(`Error de conversión: ${error.message}`);
        return null; // Retornamos null si hay un error
      }
    }
  };

  //Formatea el valor para mostrar en base al sistema ingles o español con el punto y coma o coma y punto en decimales
 export const formatValue = (num, language) => {
    // const type = language && language === "en" ? "en-US" : "de-DE";
    // let formateado = new Intl.NumberFormat(type, {
    //   // minimumFractionDigits: 2,
    //   // maximumFractionDigits: 2,
    // }).format(num);

    // return formateado;
    return num
  };

  export const DATA = {
  electricity_standard: { calorific: null, density: null },
  renewable_energies: { calorific: null, density: null },
  natural_gas: { density: 0.7, calorific: 48 },
  glp: { density: 0.54, calorific: 47.3 },
  heavy_fuel_oil: { density: 1, calorific: 40 },
  light_fuel_oil: { density: 1, calorific: 43 },
  coal: { density: 1, calorific: 25.8 },
  diesel: { density: 0.84, calorific: 43 },
  biodiesel: { density: 0.84, calorific: 43 },
  gasoline: { density: 0.74, calorific: 44.3 },
  biofuel: { density: 0.74, calorific: 44.3 },
  biomass: { density: 1, calorific: 15.6 },
  steam: { density: 1, calorific: 1 },
};
